import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/frontend/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/opt/buildhome/repo/frontend/layouts/home.vue").then(m => m.default || m))
}